/** What a draft becomes on the wire (§7.6, §17.1). */
import type { SendRequest } from './useThread'

/** PPV prices Fansly (through the gateway) takes: 0, or 1–500 dollars. */
export const PRICE_MIN = 1
export const PRICE_MAX = 500

export type PriceProblem = '' | 'invalid' | 'range' | 'needsMedia'

/** The PPV price typed (dollars) and what is wrong with it, if anything. */
export function readPrice(raw: string, hasMedia: boolean): { value: number; problem: PriceProblem } {
  const s = raw.trim().replace(',', '.')
  if (!s) return { value: 0, problem: '' }
  const value = Number(s)
  if (!Number.isFinite(value) || value < 0) return { value: 0, problem: 'invalid' }
  if (value === 0) return { value: 0, problem: '' }
  if (value < PRICE_MIN || value > PRICE_MAX) return { value, problem: 'range' }
  if (!hasMedia) return { value, problem: 'needsMedia' }
  return { value: Math.round(value * 100) / 100, problem: '' }
}

/** The send route and body for a draft (§7.6, §17.1): text, free media, paid media, a paid bundle or a voice note. */
export function sendRequestFor(d: { groupId: string; fanId: string; content: string; mediaIds: string[]; price: number; voiceMediaId?: string; now?: number }): SendRequest {
  const common = { groupId: d.groupId, _crm_fan_id: d.fanId }
  if (d.voiceMediaId) {
    return {
      path: '/crm/messages/send-voice',
      body: { ...common, recipientAccountId: d.fanId, mediaId: d.voiceMediaId, content: d.content, priceUsd: d.price, scheduledFor: 0, inReplyTo: null },
    }
  }
  if (d.mediaIds.length) {
    const path = d.price > 0 ? (d.mediaIds.length > 1 ? '/crm/messages/send-paid-bundle' : '/crm/messages/send-media') : '/crm/messages/send-free-media'
    return { path, body: { ...common, recipientAccountId: d.fanId, mediaIds: d.mediaIds, content: d.content, priceUsd: d.price } }
  }
  return {
    path: '/crm/messages/send',
    body: { ...common, content: d.content, inReplyTo: null, type: 1, attachments: [], likes: [], scheduledFor: 0, createdAt: (d.now ?? Date.now()) / 1000 },
  }
}

